import type { WithActiveBranchId } from '@app/api/shared';

export enum DebugEndpoints {
  GetClientMessageInfo = 'GetClientMessageInfo',
  ClearPriorityIntegrations = 'ClearPriorityIntegrations',
  PushMessageInBrokerMessage = 'PushMessageInBrokerMessage',
  CancelDelayedCommands = 'CancelDelayedCommands',
  CancelDelayedCommand = 'CancelDelayedCommand',
  GetCommandsByAction = 'GetCommandsByAction',
  GetAllDelayedCommands = 'GetAllDelayedCommands',
}

export interface ModelMessageBroderData {
  MessageType: number;
  BranchId: number;
  Payload: unknown | null;
  Priority: number;
  DelayMs: number;
}

export interface ModelDelayedCommandInfo {
  CommandId: string | null;
  ActionId: string | null;
  MessageType: number;
  Priority: number;
  BranchId: number;
  Queue: string | null;
  CreatedAtUtc: string;
  ExecuteAtUtc: string;
}

export type GetClientMessageInfoRequest = WithActiveBranchId<{
  messageId: number;
}>;
export type ClearPriorityIntegrationsRequest = WithActiveBranchId;
export type PushMessageInBrokerMessageRequest = WithActiveBranchId<{
  data: ModelMessageBroderData;
}>;
export type CancelDelayedCommandsRequest = WithActiveBranchId<{
  commandId: string;
}>;
export type CancelDelayedCommandRequest = WithActiveBranchId<{
  actionId: string;
}>;
export type GetCommandsByActionRequest = WithActiveBranchId<{
  actionId: string;
}>;
export type GetAllDelayedCommandsRequest = WithActiveBranchId;

export type GetClientMessageInfoResponse = string;
export type ClearPriorityIntegrationsResponse = void;
export type PushMessageInBrokerMessageResponse = string;
export type CancelDelayedCommandsResponse = void;
export type CancelDelayedCommandResponse = void;
export type GetCommandsByActionResponse = string[];
export type GetAllDelayedCommandsResponse = ModelDelayedCommandInfo[];
